import getSymbolFromCurrency from "currency-symbol-map";
import { useContext } from "react";
import { AppContext, ValueProps } from "src/context";
import { formatMoney } from "src/helper/functions";

interface Props {
  asoebiName: string;
  attireImg: string;
  attireName: string;
  price_per_yard: number;
  total_price: number;
  yards: number;
  fullname: string;
}
const OrderDetails = ({
  attireImg,
  attireName,
  price_per_yard,
  total_price,
  yards,
  fullname,
}: Props) => {
  const contextValue = useContext<ValueProps | null>(AppContext);
  const asoebiFeePercentage = contextValue?.asoebiFeePercentage ?? 0;

  return (
    <div className="h-full w-full bg-white px-4 py-14 sm:p-8">
      <div className="mb-4">
        <h2 className="text-xl font-semibold">{`${fullname}'s Order`}</h2>
        <p className="text-sm text-gray-500">
          A detailed description of asoebi purchased
        </p>
      </div>

      <div className="mb-4 flex items-end justify-between border-b py-4 sm:flex-row sm:items-center">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-center">
          <div className="h-20 w-20">
            {attireImg && (
              <img
                src={attireImg ?? ""}
                alt=".."
                className="h-full w-full object-cover"
              />
            )}
          </div>
          <div className="">
            <p className="mb-2">{attireName}</p>
            <p className="text-sm text-gray-500">
              {getSymbolFromCurrency("ngn")} {formatMoney(price_per_yard)} per
              yard
            </p>
          </div>
        </div>

        <div className="">
          <p className="mb-2 text-sm text-gray-500">{yards} yard(s)</p>
          <p className="">
            {getSymbolFromCurrency("ngn")} {formatMoney(price_per_yard)}
          </p>
        </div>
      </div>

      <div className="mb-4 flex items-center justify-between">
        <p className="text-sm text-gray-500">
          {asoebiFeePercentage}% Inawo service fee
        </p>
        <p className="">
          {getSymbolFromCurrency("ngn")}{" "}
          {formatMoney((asoebiFeePercentage * price_per_yard) / 100)}
        </p>
      </div>

      <div className="flex items-center justify-between">
        <div className="">
          <p className="">Total: {yards} item(s)</p>
        </div>

        <p className="text-xl font-semibold">
          {getSymbolFromCurrency("ngn")} {formatMoney(total_price)}
        </p>
      </div>
    </div>
  );
};

export default OrderDetails;
